









import Vue from 'vue';
import AddClientBtn from './AddClientBtn.vue';
import ClientsTable from './ClientsTable.vue';

export default Vue.extend({
  props: {
    agencyId: {
      type: String,
      required: true,
    },
  },
  components: {
    'add-client-btn': AddClientBtn,
    'clients-table': ClientsTable,
  },
});
